import JSX from "../../helpers/react.js";
import RefObject = JSX.RefObject;

export default function TextInput({value, name, placeholder, onChange, pattern, autocomplete, style, ref}: {
    value: string|undefined, name: string,
    placeholder: string, onChange?: (value?: string)=>any,
    pattern?: RegExp,
    autocomplete?: 'on'|'off',
    style?: any,
    ref?: RefObject<HTMLInputElement>
}){
    const refLocal:RefObject<HTMLInputElement> = {};
    const ans = (
        <input
            name={name}
            placeholder={placeholder}
            type="text"
            autocomplete={autocomplete}
            className="bordered"
            value={value}
            style={style}
            ref={refLocal}
            pattern={pattern?.source}
            onChange={()=>onChange?.(refLocal.value!.value)}
        />
    );
    if(ref) ref.value = refLocal.value;
    onChange?.(value??undefined)

    return ans;
}